import { CalendarCheck, Compass, KeyRound, ShoppingBag, Sparkles, UtensilsCrossed } from "lucide-react";
import { Claim, GoldRule, MaskedLine, Micro, Reveal, SlideBody, SlideShell } from "../shared";

const STEPS = [
  { icon: CalendarCheck, t: "Prenotazione", d: "Conferma, preferenze e profilo dell'ospite." },
  { icon: KeyRound, t: "Welcome", d: "Check-in digitale e guida interattiva della villa." },
  { icon: Compass, t: "Scoperta", d: "Itinerari, borghi e luoghi selezionati sulla Costiera." },
  { icon: UtensilsCrossed, t: "Servizi", d: "Chef privato, transfer e barca attivabili in un tap." },
  { icon: ShoppingBag, t: "Acquisto", d: "Prenota e paga ogni esperienza dal portale." },
  { icon: Sparkles, t: "Esperienza", d: "Ogni servizio vissuto in villa, senza attriti." },
];

export default function Slide08GuestPortal() {
  return (
    <SlideShell theme="ivory" testid="slide-8-guest-portal">
      <SlideBody>
        <Reveal>
          <Micro tone="ivory">07 · Guest Portal</Micro>
        </Reveal>
        <h2 className="mt-5 font-serif text-4xl leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.1}>IL NUOVO</MaskedLine>
          <MaskedLine delay={0.22}>
            <em className="italic text-[#997A15]">CONCIERGE DIGITALE.</em>
          </MaskedLine>
        </h2>

        <div className="relative mt-14">
          <div className="absolute left-6 right-6 top-[22px] hidden h-px bg-[#0B152C]/12 xl:block" />
          <div className="grid grid-cols-2 gap-x-6 gap-y-10 md:grid-cols-3 xl:grid-cols-6">
            {STEPS.map((s, i) => (
              <Reveal key={s.t} delay={0.35 + i * 0.1}>
                <div className="group">
                  <div className="relative z-10 flex h-11 w-11 items-center justify-center rounded-full border border-[#B8860B]/45 bg-[#FAF7F2] text-[#997A15] transition-all duration-500 group-hover:bg-[#0B152C] group-hover:text-[#D4AF37]">
                    <s.icon size={17} strokeWidth={1.6} />
                  </div>
                  <div className="mt-4 font-mono text-[10px] tracking-[0.3em] text-[#B8860B]">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <h3 className="mt-2 font-serif text-xl tracking-tight text-[#0B152C]">{s.t}</h3>
                  <p className="mt-2 text-[13px] leading-relaxed text-[#334155]">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={1.0} className="mt-14 flex items-center gap-5">
          <GoldRule tone="ivory" delay={1.0} />
          <Claim tone="ivory">The digital concierge for your stay.</Claim>
        </Reveal>
      </SlideBody>
    </SlideShell>
  );
}
